import { ROUTE_METADATA } from 'app/AppRoutes/RouteMetadata'
import { getExperienceTabKeys } from 'domains/launchdarkly/portalExperience'

const { editPatient, summaryComparison } = ROUTE_METADATA

/**
 * Formatting the tabs and their respective necessary urls/links
 *
 * Which tabs appear, and in what order, comes from the portal experience preset.
 * The Settings tab is appended independently of the preset, gated on membership
 * data rather than on LaunchDarkly.
 *
 * @returns {object[]} List of tabs to display
 */
export const getTabs = ({
  admin,
  comparisonModeEnabled,
  phiVisibility,
  portalExperience,
}) => {
  const tabArray = getExperienceTabKeys(portalExperience).map((tabKey) => {
    const { path, title } = ROUTE_METADATA[tabKey]

    if (tabKey === 'summary' && comparisonModeEnabled) {
      return { id: path, label: title, to: summaryComparison.path }
    }

    return { id: path, label: title, to: path }
  })

  if (admin || phiVisibility) {
    tabArray.push({
      id: editPatient.path,
      label: editPatient.title,
      to: editPatient.path,
    })
  }

  return tabArray
}
